
import React from "react";

// MUI Components:
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

function ServicePaper( {paper_icon, oService}) {

    return(

        <Paper
            elevation={2} 
            sx={{ width:'90%', 
                    height:"auto", 
                    borderRadius:'1rem',
                    padding:'1rem',
                    margin:'1rem',
                    marginBottom:'1.5rem',
                    marginTop:0,
                    "@media (min-width: 600px) and (max-width: 1024px)" : {
                        width:"30%",
                        maxWidth: '30%',
                        padding:'1.5rem'
                    },
                    "@media (min-width:1024px) and (max-width:1280px)" : {
                        width: '30%',
                        maxWidth: '30%',
                        padding:'1.5rem'
                    },
                    "@media screen and (min-width:1280px)" : {
                        width: '30%',
                        maxWidth: '30%',
                        padding:'1.5rem'
                        }         
        }}>
        <Box  display={'flex'} justifyContent={'center'}>
            {
              paper_icon
            }
            
        </Box>
        <Box display={'flex'} justifyContent={'center'} textAlign={'center'}>
            <Typography variant="h6" sx={{fontWeight:'bolder'}}>{oService.service_title}</Typography>
        </Box>
        
        <Box display={'flex'} justifyContent={'center'} textAlign={'center'} sx={{marginTop:'0.3rem'}} >
            <Typography sx={{fontSize:'1rem',color:'#0000008A'}}> {oService.service_descr} </Typography>
        </Box>

        
    </Paper>

    )
}

export default ServicePaper;